<template>
    <div id="step5">
        <h3><img src="../assets/images/step5-title.svg"> カーテンをかける部屋名・場所を入力する</h3>
        <div>
            <input id="living" class="room_radio" type="radio" v-model="room_selected" value="リビング">
            <label for="living">
                <img v-bind:src="[room_selected=='リビング' ? './assets/images/living_o.svg' : './assets/images/living.svg']">
<!--                <span v-html="svg_html.living"></span>-->
<!--                {{living_svg}}-->
<!--                <p class="room_name">リビング</p>-->
            </label>
            <input id="dining" class="room_radio" type="radio" v-model="room_selected" value="ダイニング">
            <label for="dining">
                <img v-bind:src="[room_selected=='ダイニング' ? './assets/images/dining_o.svg' : './assets/images/dining.svg']">
<!--                <img src="../assets/images/dining.svg">-->
<!--                <span v-html="svg_html.dining"></span>-->
<!--                <p class="room_name">ダイニング</p>-->
            </label>
            <input id="bedroom" class="room_radio" type="radio" v-model="room_selected" value="寝室">
            <label for="bedroom">
<!--                <img src="../assets/images/bedroom.svg">-->
                <img v-bind:src="[room_selected=='寝室' ? './assets/images/bedroom_o.svg' : './assets/images/bedroom.svg']">
<!--                <span v-html="svg_html.bedroom"></span>-->
<!--                <p class="room_name">寝室</p>-->
            </label>
            <input id="kidsroom" class="room_radio" type="radio" v-model="room_selected" value="子供部屋">
            <label for="kidsroom">
                <img v-bind:src="[room_selected=='子供部屋' ? './assets/images/kidsroom_o.svg' : './assets/images/kidsroom.svg']">
<!--                <img src="../assets/images/kidsroom.svg">-->
<!--                <span v-html="svg_html.kidsroom"></span>-->
<!--                <p class="room_name">子供部屋</p>-->
            </label>
            <input id="bedroom2" class="room_radio" type="radio" v-model="room_selected" value="洋室">
            <label for="bedroom2">
                <img v-bind:src="[room_selected=='洋室' ? './assets/images/room_o.svg' : './assets/images/room.svg']">
<!--                <img src="../assets/images/room.svg">-->
<!--                <span v-html="svg_html.room"></span>-->
<!--                <p class="room_name">洋室</p>-->
            </label>
            <input id="japanese-room" class="room_radio" type="radio" v-model="room_selected" value="和室">
            <label for="japanese-room">
                <img v-bind:src="[room_selected=='和室' ? './assets/images/japanese_room_o.svg' : './assets/images/japanese_room.svg']">
<!--                <img src="../assets/images/japanese_room.svg">-->
<!--                <span v-html="svg_html.japanese_room"></span>-->
<!--                <p class="room_name">和室</p>-->
            </label>

<!--            <label class="icon_btn" v-model="room_selected" name="" value="リビング">-->
<!--                <img src=".././assets/images/19IM_S_プレーンシェード.svg">-->
<!--               -->
<!--                <input type="radio" value="リビング">-->
<!--            </label>-->
<!--            <label class="icon_btn" v-model="room_selected" name="" value="ダイニング">-->
<!--                <img src=".././assets/images/19IM_S_プレーンシェード.svg">-->
<!--                <p>ダイニング</p>-->
<!--                <input type="radio" value="ダイニング">-->
<!--            </label>-->
<!--            <label class="icon_btn" v-model="room_selected" name="" value="寝室">-->
<!--                <img src=".././assets/images/19IM_S_プレーンシェード.svg">-->
<!--                <p>寝室</p>-->
<!--                <input type="radio" value="寝室">-->
<!--            </label>-->
<!--            <label class="icon_btn" v-model="room_selected" name="" value="子供部屋">-->
<!--                <img src=".././assets/images/19IM_S_プレーンシェード.svg">-->
<!--                <p>子供部屋</p>-->
<!--                <input type="radio" value="子供部屋">-->
<!--            </label>-->
<!--            <label class="icon_btn" v-model="room_selected" name="" value="洋室">-->
<!--                <img src=".././assets/images/19IM_S_プレーンシェード.svg">-->
<!--                <p>洋室</p>-->
<!--                <input type="radio" value="洋室">-->
<!--            </label>-->
<!--            <label class="icon_btn" v-model="room_selected" name="" value="和室">-->
<!--                <img src=".././assets/images/19IM_S_プレーンシェード.svg">-->
<!--                <p>和室</p>-->
<!--                <input type="radio" value="和室">-->
<!--            </label>-->

<!--            <div>-->
<!--                <label>-->
<!--                    その他-->
<!--                    <input type="text">-->

<!--                </label>-->
<!--            </div>-->
            <div class="other_room">
                その他<b-form-input style="margin-bottom: 0; width: 200px; font-size: 0.9rem;" class="input_size" v-model="other_room" placeholder="その他"></b-form-input>
                <p style="padding-left: 4rem; padding-bottom: 0px; margin: 0px;">※10文字以内</p>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'STEP5',
        computed: {
            other_room :{
                get: function () {
                    return this.$store.state.step5_data.other_selected
                },
                set: function (value) {
                    this.$store.commit('updateRoomSelected', value)
                    this.$store.commit('updateRoomOtherSelected', value);
                }
            },
            room_selected: {
                get: function () {
                    return this.$store.state.step5_data.room_selected
                },
                set: function (value) {
                    this.$store.commit('updateRoomSelected', value);
                    this.$store.commit('updateRoomOtherSelected', '');
                }
            }
        },
        created : function () {
            // for(let i=0; i<this.room_svg.length; i++){
            //     this.load_svg(this.room_svg[i])
            // }
        },
        data() {
            return {
                svg_html: {'living':null,'dining':null,'bedroom':null,'kidsroom':null,'room':null,'japanese_room':null},
                room_svg : ['living','dining','bedroom','kidsroom','room','japanese_room']
            }
        },
        methods : {
            load_svg: function(_file_name){
                const req = new XMLHttpRequest()
                req.open('GET', './assets/images/'+_file_name+'.svg', true)
                req.responseType = 'text'
                const scope = this

                //ローディングをつける　TODO
                req.onload = function () {
                    //console.log('ファイル読み込み成功',req.responseText)
                    //console.log('ファイル読み込み成功')
                    if ( req.response.indexOf('<!DOCTYPE html>') != -1) {
                        console.log('ファイル読み込み失敗1')
                        return false
                    }
                    //データを処理
                    //document.getElementById("living").appendChild( req.responseXML )
                    scope.svg_html[_file_name] = req.responseText
                }
                req.onerror = function() {
                    //console.log('ファイル読み込み失敗2')
                    return false
                }
                req.send();
            }
        }
    }
</script>

<style scoped>

</style>